// eslint-disable-next-line import/no-cycle
import {
  loadActivities, loadActivityData, updateActivity,
} from '@/services/repository';

import {
  LOAD_ACTIVITIES, LOAD_ACTIVITY_DATA, RESET_ACTIVITY_DATA, UPDATE_ACTIVITY,
} from '@/store/activity/actionTypes';
import {
  CLEAR_ACTIVITIES,
  CLEAR_ACTIVITY_DATA, CLEAR_REPORT_ACTIVITIES,
  SET_ACTIVITIES,
  SET_ACTIVITIES_LOADING,
  SET_ACTIVITY_DATA, SET_REPORT_ACTIVITIES,
} from '@/store/activity/mutationTypes';

export default {
  async [LOAD_ACTIVITIES]({ commit, state }, payload) {
    const previousActivities = state.activities;
    commit(SET_ACTIVITIES_LOADING, true);
    try {
      const activities = await loadActivities(payload);
      if (payload?.type) {
        commit(CLEAR_REPORT_ACTIVITIES);
        commit(SET_REPORT_ACTIVITIES, activities);
      } else {
        // Only update if data actually changed, avoids unnecessary re-renders
        const hasChanged = JSON.stringify(activities) !== JSON.stringify(previousActivities);
        if (hasChanged) commit(SET_ACTIVITIES, activities);
      }
    } catch (e) {
      // Don't clear existing activities on poll failure — keep showing stale data
      if (!previousActivities.length) {
        commit(CLEAR_ACTIVITIES);
        commit(CLEAR_REPORT_ACTIVITIES);
      }
    } finally {
      commit(SET_ACTIVITIES_LOADING, false);
    }
  },
  async [LOAD_ACTIVITY_DATA]({ commit }, payload) {
    try {
      const activity = await loadActivityData(payload);
      commit(SET_ACTIVITY_DATA, activity);
    } catch (e) {
      commit(CLEAR_ACTIVITY_DATA);
    }
  },
  async [RESET_ACTIVITY_DATA]({ commit }) {
    commit(CLEAR_ACTIVITY_DATA);
  },
  async [UPDATE_ACTIVITY]({dispatch}, payload) {
    try {
      const {
        activityId,
        updates,
      } = payload;
      await updateActivity(activityId, updates);
      await dispatch(LOAD_ACTIVITIES);
    } catch (e) {
      console.error(e);
    }
  },
};
